import { getFeatureEnabled, configQuery } from '@gig/magic-common';
import { Feature } from '@gig/magic-messages';
import { __awaiter, __generator } from 'tslib';

var AlternateLinkService = /** @class */ (function () {
    function AlternateLinkService() {
        this.baseUrl = '';
        this.hreflang = '';
    }
    AlternateLinkService.prototype.setAlternateTag = function (url, options) {
        var _this = this;
        this.isEnabled().then(function (enabled) {
            if (!enabled) {
                return;
            }
            var tag = _this.queryOrCreateTag();
            tag.setAttribute('rel', 'alternate');
            tag.setAttribute('hreflang', _this.hreflang);
            tag.setAttribute('data-v-test-id', 'alternate-tag');
            var href = options.useBaseUrl ? _this.concatBaseUrl(url) : url;
            tag.setAttribute('href', href);
        });
    };
    AlternateLinkService.prototype.destroyAlternateTag = function () {
        var _this = this;
        this.isEnabled().then(function (enabled) {
            if (!enabled) {
                return;
            }
            var tag = _this.queryTag();
            if (tag) {
                tag.remove();
            }
        });
    };
    AlternateLinkService.prototype.concatBaseUrl = function (url) {
        if (url.startsWith('/')) {
            url = url.substring(1);
        }
        if (this.baseUrl.endsWith('/')) {
            return this.baseUrl + url;
        }
        return this.baseUrl + '/' + url;
    };
    AlternateLinkService.prototype.isEnabled = function () {
        return __awaiter(this, void 0, void 0, function () {
            var enabled;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getFeatureEnabled(Feature.HREFLANG_ON_PAGE)];
                    case 1:
                        enabled = _a.sent();
                        if (!enabled) {
                            return [2 /*return*/, false];
                        }
                        return [4 /*yield*/, this.queryConfig()];
                    case 2:
                        _a.sent();
                        if (!this.baseUrl || !this.hreflang) {
                            return [2 /*return*/, false];
                        }
                        return [2 /*return*/, true];
                }
            });
        });
    };
    AlternateLinkService.prototype.queryOrCreateTag = function () {
        var tag = this.queryTag();
        if (tag) {
            return tag;
        }
        var createdTag = document.createElement('link');
        document.head.appendChild(createdTag);
        return createdTag;
    };
    AlternateLinkService.prototype.queryTag = function () {
        return document.querySelector("link[rel=alternate]");
    };
    AlternateLinkService.prototype.queryConfig = function () {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var config;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, configQuery('seo')];
                    case 1:
                        config = _c.sent();
                        if (!((_a = config === null || config === void 0 ? void 0 : config.alternateLink) === null || _a === void 0 ? void 0 : _a.baseUrl) ||
                            !((_b = config === null || config === void 0 ? void 0 : config.alternateLink) === null || _b === void 0 ? void 0 : _b.hreflang)) {
                            // eslint-disable-next-line no-console
                            console.log("Alternate link not configured properly. Use the \"seo.alternateLink\" configuration property to set the base url and hreflang. Example: { baseUrl: 'https://www.mycasino.com/', hreflang: 'en-ca' }");
                            return [2 /*return*/];
                        }
                        this.baseUrl = config.alternateLink.baseUrl;
                        this.hreflang = config.alternateLink.hreflang;
                        return [2 /*return*/];
                }
            });
        });
    };
    return AlternateLinkService;
}());
var alternateLink = new AlternateLinkService();

export { AlternateLinkService, alternateLink };
